/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.vodafone.pt/portalprivacidade.html#topics_sua_privacidade",
  "cookie-preferences": "https://www.vodafone.pt/portalprivacidade.html#topics_cookies",
  "terms-and-conditions": "https://www.vodafone.pt/info/termos-condicoes.html",
  accessibility: "accessibility",
  "help-and-support": "https://www.vodafone.pt/content/digitalhelp/pt/ajuda.html?tab=servicos-apps",
};
